import React from "react"
import { StaticQuery , graphql } from "gatsby"
import Layout from "../components/layout"
import FooterSlider from "../components/footer_slider"
import SEO from "../components/seo"
import { Remarkable } from 'remarkable';
import Slider from 'react-animated-slider';
import 'react-animated-slider/build/horizontal.css';


var md = new Remarkable();

const slides = [
    { title: 'First item', description: 'Lorem ipsum'},
    { title: 'Second item', description: 'Lorem ipsum'},
    { title: 'Third item', description: 'Lorem ipsum'}
  ];

const IndexPage = () => (

    

  <StaticQuery query={Homepage} render={data=>{

    const allData = data.allMarkdownRemark.edges[0].node.frontmatter
    // console.log(data.allMarkdownRemark.edges[0].node.frontmatter.slider2)
    console.log(allData)


  return ( 
      
    
    <div>
    <Layout>
        <SEO title="Blue Economy" /> 

        {/* Sesction 1 start here */}

           <section id="slider" class="hero p-0 odd">
            <div class="swiper-container no-slider animation slider-h-100 slider-h-auto">
                <div class="swiper-wrapper">

                   
                    <div class="swiper-slide slide-center">

                        <img src={allData.image} alt="Full Image" class="full-image" data-mask="0"/>

                        <div class="slide-content row">
                            <div class="col-12 d-flex justify-content-start inner">
                                <div class="center text-center">
                                    <h1> 
                                        {allData.title}
                                        {/* Title */}
                                    </h1>
                                    <p class="description bigger">
                                        {allData.description}

                                    </p>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>  
        {/* Sesction 1 end here */}

        {/* Sesction 2 start here */}
        <section id="services" class="section-3 odd offers" style={{background:"black"}}>
            <div class="container-fluid">
                            
                        

                    <div class="row justify-content-center items">
                       
                        {allData.section2.map(tag => (
                        <div class="col-12 col-md-6 col-lg-4 item">
                       <div class="card" style={{textAlign:'center', color:'white'}}>
                                
                                {/* <i class="icon featured icon-people"></i> */}
                                <img src={tag.image} style={{width:'124px', height:'130px', margin:'auto'}} />
                                <h4 style={{color:'white'}}> 
                                    {tag.title}
                                </h4>
                                <p style={{textAlign:'justify'}}>{tag.dsecription}</p>
                                <div class="col-12 col-md-6 align-self-end">
                                        <a href={tag.link} class="btn mx-auto mr-md-0 ml-md-auto outline-button">Read More</a>
                                </div>
                            
                            </div>
                        </div>
                        ))}
                    
                    
                    </div>
                
            </div>
        </section>
        



        {/* Sesction 2 end here */}

        {/*   section 3 start here  */}

        <section id="partners" class="section-1 offers testimonials" style={{background: '#eef4ed'}}>
            <div class="container">
              <div>
                <div class="row text-center intro">
                    <div class="col-12">
                        
                        <h2> {allData.section3.title} </h2>
                        <p class="text-max-800">{allData.section3.dsecription}</p>
                        
                    </div>
                </div>

                {/* <a href={allData.section3.link} class="btn mx-auto ml-md-auto outline-button">Learn More</a>     */}
                <a href='#' class="btn mx-auto ml-md-auto outline-button">Learn More</a>    
                </div>
            </div>
        </section>

          
        {/*   section 3 end here  */}


      {/* section 4 start here */}
      <section id="services" class="section-3 odd offers" style={{background:"black"}}>
            <div class="container">
                <div class="row intro">
                    <div class="col-12 col-md-9 align-self-center text-center text-md-left">
                        <h2>Our Work Philosophy</h2>
                        
                    </div>
                </div>
               
                <div class="row justify-content-center items">
                    {allData.section4.map(tag => (
                        <div class="col-12 col-md-6 col-lg-4 item">
                            <div class="card">
                                <i class="icon icon-briefcase"></i>
                                <h4>
                                    {tag.title}
                                </h4>
                                <p>Lorem ipsum dolor sit amet consectetur adipiscing elit.</p>
                               
                                <p>
                                    {tag.dsecription}
                                </p>
                                <a href={tag.link}><i class="btn-icon pulse fas fas fa-arrow-right"></i></a>
                            </div>
                        </div>
                    ))}
               
                </div>




            </div>
        </section>

        {/* section 4 end here */}

        {/* section 5 start here */}
        <section class="section-2" style={{background: '#eef4ed'}}>
            <div class="container">
                
                <h2 style={{textAlign: "center"}}>Latest News</h2> 
                
                <Slider style={{width:'400px'}} autoplay={1000} infinite={true}>
                    {allData.section5.map((slide, index) => <div key={index}>
                        <h2 style={{textAlign:'center'}}>{slide.title}</h2>
                        <div style={{textAlign:'center'}}>{slide.dsecription}</div>
                    </div>)}
                </Slider>  
            </div>
        </section>
        {/* section 5 end here */}

        {/* section 6 start here */}

        <section class="section-2" style={{background: '#eef4ed'}}>
            <div class="container"> 
                
                <h2 style={{textAlign: "center" }}>Latest Events</h2> 
                
                <Slider style={{width:'400px'}} autoplay={1500} infinite={true}>
                    {allData.news_slider.map((slide, index) => <div key={index}>
                        <h2 style={{textAlign:'center'}}>{slide.title}</h2>
                        <div style={{textAlign:'center'}}>{slide.dsecription}</div>
                    </div>)}
                </Slider>  
            </div>
        </section>

        {/* section 6 end here */}

        {/* section 7 start here */}
        
        <section class="section-2" style={{background: '#eef4ed'}}>
            <div class="container">
                
                <h2 style={{textAlign: "center"}}> Sponsors </h2> 
                
                <Slider style={{width:'400px'}} autoplay={2000} infinite={true}>
                    {allData.sponsor_slider.map((slide, index) => <div key={index}>
                        <h2 style={{textAlign:'center'}}>{slide.title}</h2>
                        <div style={{textAlign:'center'}}>{slide.dsecription}</div>
                    </div>)}
                </Slider>  
            </div>
        </section>

        {/* section 7 end here */}


        {/* section 8 start here */}

        <section class="section-2">
            <div class="container">
                <h2 style={{textAlign:"center"}}>Get in touch</h2>
                <div class="row">

                    <div class="col-12 col-lg-12">
                        <form>
                            <input type="hidden" name="section" value="nexgen_form"/>

                            <input type="hidden" name="reCAPTCHA"/>
                           

                            <div class="row form-group-margin">
                                <div class="col-12 col-md-6 col-lg-6 m-0 p-2 input-group">
                                    <input type="text" name="name" class="form-control field-name" placeholder="First Name"/>
                                </div>

                                <div class="col-12 col-md-6 col-lg-6 m-0 p-2 input-group">
                                    <input type="text" name="last_name" class="form-control field-email" placeholder="Last Name"/>
                                </div>
                                <br></br>
                                <div class="col-12 m-0 p-2 input-group">
                                    <input type="text" name="email" class="form-control field-phone" placeholder="Email *"/>
                                </div>
                                <div class="col-12 m-0 p-2 input-group">
                                    <input type="text" name="email" class="form-control field-phone" placeholder="Subject"/>
                                </div>
                                <div class="col-12 m-0 p-2 input-group">
                                    <textarea name="message" class="form-control field-message" placeholder="Message *"></textarea>
                                    
                                </div>
                                <div class="col-12 col-12 m-0 pl-md-2">
                                    <span class="form-alert"></span>
                                </div>
                                <div class="col-12 input-group m-0 p-2">
                                    <a class="btn primary-button">Submit</a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>

        
        {/* section 8 end here */}

      


      </Layout>
    </div>
  
  )
}}/>
)

export const Homepage = graphql`
query HomeIndex {
  allMarkdownRemark(filter: {fileAbsolutePath: {regex: "posts/homepage/"}}) {
    edges {
      node {
        id
        frontmatter {
          title
          description
          image
          section2{
              title
              dsecription
              image
              link
          }
          section3{
              title
              dsecription
              link
          }
          section4{
              title
              dsecription
              link
          }
          section5{
              title
              dsecription
          }
          news_slider{
              title
              dsecription
          }
          sponsor_slider{
              title
              dsecription
          }
         
        }
      }
    }
  }
}


`


export default IndexPage
